<template>
  <div class="knowledge">
    <span
      class="knowledge-answer"
      v-for="item in topicInfo.row.option" :key="item.id ">
      {{item.key}}.
      <span v-katexHtml="item.content"></span>
      <img :src="url" :key="url" v-for="url in getImgList(item)" alt="">
    </span>
    <!-- 正确答案 -->
    <div class="knowledge-true">
      <strong>正确答案 ：</strong>
      <span
        class="knowledge-answer knowledge-true__answer"
        v-for="item in answer"
        :key="item .id"
        v-katexHtml="item.content"
        ></span>
    </div>
    <!-- 单选/多选错误答案 -->
    <!-- <ul v-if="topicInfo.row.question_type != 3">
      <li v-for="(item, index) in wrongList" :key="index">
        <span class=knowledge-wrong>
          <span v-if="item.answer"> 错误答案 {{item.answer}}</span>
          <span v-else>跳过此题</span>
          : {{item.num}} 人</span>
        <span
          class="knowledge-error"
          v-for="(study, id) in item.student_list"
          :key="id">
          {{study}}
          <span v-if="item.student_list.length > 1 &&  item.student_list.length -1 !== id">、</span>
        </span>
      </li>
    </ul> -->
    <!-- 填空题错误答案渲染 -->
    <!-- <el-table
      v-else
      :data="wrongList"
      border
      style="width: 90%">
      <el-table-column
        prop="answer"
        label="答案信息"
        align="center"
        width="300">
        <template slot-scope="scope">
         <div v-if="scope.row.answer !== ''" v-katexHtml='`\\(${scope.row.answer}\\)`'>
         </div>
         <div v-else>
           跳过此题
         </div>
       </template>
      </el-table-column>
      <el-table-column
        prop="student_list"
        align="center"
        width="120"
        label="答错人数">
        <template slot-scope="scope">
         <div>
           {{ scope.row.student_list.length }}人
         </div>
       </template>
      </el-table-column>
      <el-table-column
        prop="error_than"
        align="center"
        width="120"
        label="答错占比">
        <template slot-scope="scope">
         <div>
           {{ scope.row.error_than }}%
         </div>
       </template>
      </el-table-column>
      <el-table-column
        prop="student_list"
        align="center"
        label="学生明细">
        <template slot-scope="scope">
         <div v-if="scope.row.student_list.length>0">
           {{ scope.row.student_list.join('、') }}
         </div>
       </template>
      </el-table-column>
    </el-table> -->
    <!-- 文字解析 -->
    <div class="knowledge-analysis" v-if="isEmptyAnalye">
      <strong>文字解析:</strong>
      <div class="knowledge-analysis__text">
        <p v-for=" item in analyze" :key="item.id" v-katexHtml="item.content"></p>
      </div>
    </div>
    <!-- 视屏解析 -->
    <div class="knowledge-video" v-if="videoDate">
      <strong>视频解析:</strong>
      <div class="knowledge-video__button" round @click="openVideo">{{duration}}</div>
    </div>
    <!-- 所属知识点 -->
    <div class="knowledge-be">
      <strong>所属知识点:</strong>
      <div class="knowledge-be__text" v-for="item in knowledgeName" :key="item.id">
        {{item.knowledge_name}}
      </div>
    </div>

    <DetailedDialog :isShow.sync="isShow" :type="type" :videoUrl="videoDate" />
  </div>
</template>

<script>
import DetailedDialog from '@/views/pt/components/detailed-dialog.vue';
import { studentsFinishInfo } from '@/api/pt';
// import { htmlEncodeByRegExp } from '@/utils/index';

export default {
  name: 'Cknowledge',
  components: {
    DetailedDialog,
  },
  props: {
    topicInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShow: false,
      type: false,
      answer: [],
      analyze: [], // 答案解析
      videoDate: '', // 视频解析
      knowledgeName: [], // 所属知识点
      duration: '',
      wrongList: [],
      evaluateId: '',
      classId: '',
    };
  },
  computed: {
    isEmptyAnalye() {
      return this.analyze.some((item) => item.content);
    },
  },
  created() {
    this.evaluateId = this.$route.query.evaluateId;
    this.classId = this.$route.query.classId;
  },
  mounted() {
    this.answer = [].concat(...this.topicInfo.row.answer);
    this.analyze = [].concat(...this.topicInfo.row.analyze);
    this.videoDate = this.topicInfo.row.video_data[0]
      && this.topicInfo.row.video_data[0].source;
    console.log(this.videoDate);
    this.knowledgeName = this.topicInfo.row.knowledge;
    // console.log(this.knowledgeName);
    this.videoTime();
    this.studentsFinishInfo();
  },
  methods: {
    getImgList(data) {
      if (!data.img_data) {
        return [];
      }
      return data.img_data.map((item) => item.source);
    },
    openVideo() {
      this.isShow = true;
    },
    studentsFinishInfo() {
      studentsFinishInfo({
        type: this.$attrs.classType || this.$route.query.classType,
        batch_id: this.$attrs.batchId || this.$route.query.batchId,
        evaluate_id: this.evaluateId,
        class_id: this.classId,
        question_id: this.topicInfo.row.question_uuid,
      }).then(({ data }) => {
        this.wrongList = data;
      });
    },
    videoTime() {
      const audio = new Audio(this.videoDate);
      // 元数据已加载
      audio.addEventListener('loadedmetadata', () => {
        // this.duration = audio.duration;
        if (audio.duration < 60) {
          this.duration = `00:${audio.duration}`;
          return;
        }
        let m = Math.floor(audio.duration / 60);
        let s = Math.floor(audio.duration % 60);
        s = s < 10 ? `0${s}` : s;
        m = m < 10 ? `0${m}` : m;
        this.duration = `${m} : ${s}`;
        console.log(this.duration);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .knowledge {
    box-sizing: border-box;
    position: relative;
    min-height: 300px;
    background: #F5F7FA;
    border-radius: 8px;
    padding: 27px 0px 28px 45px;
    font-family: 'PingFangSC-Medium', 'PingFang SC';
    &-answer {
      padding-right: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #606266;
       p {
        display: inline;
      }
    }
    img {
      max-width: 100px;
    }
    &-true {
      margin-top: 32px;
      margin-bottom: 10px;
      font-size: 16px;
      color: #000000;
      &__answer {
        color: #67C23A;
      }
    }
    &-wrong {
      font-size: 14px;
      font-weight: 600;
      color: #F56C6C;
      margin-right: 17px;
    }
    &-error {
      font-size: 14px;
      color: #606266;
    }
    &-analysis {
      margin-top: 20px;
      font-size: 16px;
      color: #000000;
      position: relative;
      &__text {
        position: relative;
        // margin-left: 10px;
        left: 88px;
        top: -18px;
        p {
          display: inline-block;
          max-width: 950px;
          font-size: 14px;
          font-weight: 600;
          color: #606266;
          vertical-align: top;
        }
      }

    }
    &-video {
      font-size: 16px;
      margin-top: 16px;
      color: #000000;
      &__button {
        text-indent: 33px;
        display: inline-block;
        line-height: 28px;
        width: 84px;
        height: 28px;
        font-size: 12px;
        margin-left: 32px;
        color: #fff;
        border: 1px solid #ccc;
        border-radius: 14px;
        background: url('~@/views/pt/images/class_video.png')
        no-repeat #FFA82D 2px 2px;
      }
    }
    &-be {
      margin-top: 32px;
      color: #5E6166  ;
      &__text {
        display: inline-block;
        font-size: 14px;
        padding: 9px 13px;
        border-radius: 4px;
        line-height: 12px;
        border: 1px solid #DCDFE6;
        margin-left: 16px;
      }
    }
  }
</style>
